import { render, staticRenderFns } from "./selectWay.vue?vue&type=template&id=b22c1a8e&scoped=true&"
import script from "./selectWay.vue?vue&type=script&lang=js&"
export * from "./selectWay.vue?vue&type=script&lang=js&"
import style0 from "./selectWay.vue?vue&type=style&index=0&id=b22c1a8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22c1a8e",
  null
  
)

export default component.exports